<template>
  <div class="detail d-flex flex-wrap" v-if="isMode !== 'minimal'">
    <v-col class="column-container">
      <v-btn
        class
        :href="'/map'"
        id="show-more-map-button"
        rounded
        color="warning"
      >
        <v-icon left>mdi-map</v-icon>แผนที่ COVID-19
      </v-btn>
      <v-btn
        id="lock-map-button"
        v-on:click="toggleBlockMap"
        rounded
        color="primary"
      >
        {{ btnBlockMapTxt }}
      </v-btn>
      <div
        id="mobile-block-map"
        v-show="isToggleBlockMap"
        class="div-overlay-map"
      >
        block
      </div>
      <!-- <div id="button-block-map" class="div-overlay-map"> -->
      <!-- <v-btn
        v-on:click="toggleBlockMap"
        color="info"
        ref="bottonActiveteMap"
        class="botton-activete-map"
        >{{ btnBlockMapTxt }}</v-btn
      > -->
      <!-- </div> -->
      <div id="map"></div>
    </v-col>
    <v-col class="column-container">
      <v-tabs
        show-arrows
        background-color="primary"
        dark
        slider-color="white"
        v-model="tab"
      >
        <v-tab ripple>ภาพรวม</v-tab>
        <v-tab ripple>ผู้ป่วยใหม่</v-tab>
        <!-- <v-tab v-if="isMode !== 'graph'" ripple>รายจังหวัด</v-tab> -->
        <!-- <v-tab ripple>เรียงตามอายุ</v-tab> -->
        <v-tab ripple>เรียงตามจังหวัด</v-tab>
        <v-tab-item>
          <v-card color="#fff" class="thailandChart pa-2">
            <apexchart
              width="100%"
              height="400px"
              type="line"
              :options="thailandChartOptions"
              :series="series"
            ></apexchart>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card color="#fff" class="thailandChart pa-2">
            <apexchart
              type="line"
              width="100%"
              height="400px"
              :options="newConfirmedChartOptions"
              :series="seriesNewConfirmed"
            ></apexchart>
          </v-card>
        </v-tab-item>
        <!-- <v-tab-item v-if="isMode !== 'graph'">
          <div
            class="pa-2"
            style="font-size: 16px; text-align: start; color: #666666"
          >
            {{ seletedProvince }}
          </div>
          <v-data-table
            :headers="headers"
            :items="provinceCaseTable"
            :items-per-page="4"
            :sort-by="['no']"
            :sort-desc="[true]"
            class="elevation-1"
            height="270px"
          >
            <template v-slot:item.no="{ item }">{{
              numberWithCommas(item.no)
            }}</template>
          </v-data-table>
        </v-tab-item> -->
        <!-- <v-tab-item>
          <div id="chart">
            <apexchart
              type="bar"
              height="360"
              :options="barChartOptions"
              :series="barSeries"
            ></apexchart>
          </div>
        </v-tab-item> -->
        <v-tab-item>
          <v-data-table
            height="300px"
            :headers="rangeHeaders"
            :items="provinceCaseRangeTable"
            :items-per-page="10"
            :sort-by="['total_case']"
            :sort-desc="[true]"
            class="elevation-1"
          >
            <template v-slot:item.total_case="{ item }">{{
              numberWithCommas(item.total_case)
            }}</template>
          </v-data-table>
        </v-tab-item>
      </v-tabs>
      <div class="copyright copyright-desktop">
        <div>
          <div>Powered by</div>
          <div>
            <a href="https://map.longdo.com">
              <img
                style="height: 21px; margin-top: 8px; margin-left: 8px"
                :src="require('@/assets/longdo.png')"
              />
            </a>
          </div>
        </div>
        <div>
          <div>ข้อมูลจาก</div>
          <div>
            <a href="https://covid19.ddc.moph.go.th/">
              <img
                style="height: 35px; margin-left: 8px"
                :src="require('@/assets/moph.png')"
              />
            </a>
          </div>
          <div>
            <a href="https://kidkarnmai.com">
              <img
                style="height: 24px; margin-left: 8px"
                :src="require('@/assets/160Orange.png')"
              />
            </a>
          </div>
        </div>
      </div>
      <div class="copyright copyright-mobile">
        <div>
          <div>Powered by</div>
          <div>
            <a href="https://map.longdo.com">
              <img
                style="height: 21px; margin-top: 8px; margin-left: 8px"
                :src="require('@/assets/longdo.png')"
              />
            </a>
          </div>
        </div>
        <div>
          <div>ข้อมูลจาก</div>
          <div>
            <a href="https://covid19.ddc.moph.go.th/">
              <img
                style="height: 35px; margin-left: 8px"
                :src="require('@/assets/moph.png')"
              />
            </a>
          </div>
          <div>
            <a href="https://kidkarnmai.com">
              <img
                style="height: 24px; margin-left: 8px"
                :src="require('@/assets/160Orange.png')"
              />
            </a>
          </div>
        </div>
      </div>
    </v-col>
  </div>
</template>

<script>
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";
import axios from "axios";
import VueAxios from "vue-axios";
import thailandLowWKT from "@/assets/thailandVector.json";
// import LongdoLogo from "@/assets/longdo.png";

Vue.use(VueAxios, axios);
Vue.component("apexchart", VueApexCharts);

export default {
  name: "Detail",
  props: {
    // msg: String
  },
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      isToggleBlockMap: true,
      btnBlockMapTxt: "เลื่อนแผนที่",
      isMobile: false,
      timelineJson: [],
      thailandLowWKT: thailandLowWKT,
      covidProvince: [],
      tempFillColor: undefined,
      cases: [],
      dataCaseFromProvince: [],
      isMode: "default",
      map: undefined,
      tab: 1,
      sumMenAge: [],
      sumFemaleAge: [],
      selectedPolygon: undefined,
      isInSelectedPolygon: undefined,
      seletedProvince: "กรุณาเลือกจังหวัดบนแผนที่",
      thailandChartOptions: {
        chart: {
          type: "line",
          zoom: {
            enabled: true,
          },
          group: "timeline",
        },
        colors: ["#5EAAFF", "#FFC431", "#4BC09E", "#F14554"],
        dataLabels: {
          // enabled: true,
          // labels: {
          //     formatter: function (val) {
          //         return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
          //     }
          //   }
        },
        stroke: {
          curve: "straight",
          width: 3,
          show: true,
          // dashArray: [0, 5]
          // curve: 'stepline',
        },
        title: {
          text: "คน",
          align: "left",
        },
        grid: {
          show: true,
          borderColor: "#90A4AE",
          strokeDashArray: 1,
          xaxis: {
            lines: {
              show: true,
            },
          },
          yaxis: {
            lines: {
              show: true,
            },
          },
          row: {
            colors: ["#e5e5e5", "transparent"],
            opacity: 0.5,
          },
          column: {
            colors: ["#f8f8f8", "transparent"],
            opacity: 0.1,
          },
        },
        xaxis: {
          type: "datetime",
          tooltip: {
            enabled: false,
          },
          min: new Date().getTime() - 86400000 * 30,
          max: new Date().getTime() - 86400000,
        },
        yaxis: [
          {
            labels: {
              formatter: function (val) {
                return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
              },
            },
          },
        ],
      },
      newConfirmedChartOptions: {
        chart: {
          type: "line",
          group: "timeline",
          dropShadow: {
            enabled: true,
            color: "#000",
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2,
          },
          zoom: {
            enabled: true,
          },
        },
        colors: ["#77B6EA", "#545454"],
        dataLabels: {
          enabled: true,
        },
        stroke: {
          curve: "smooth",
        },
        title: {
          text: "อัตราการพบผู้ป่วยใหม่",
          align: "left",
        },
        grid: {
          show: true,
          borderColor: "#90A4AE",
          strokeDashArray: 1,
          xaxis: {
            lines: {
              show: true,
            },
          },
          yaxis: {
            lines: {
              show: true,
            },
          },
          row: {
            colors: ["#e5e5e5", "transparent"],
            opacity: 0.5,
          },
          column: {
            colors: ["#f8f8f8", "transparent"],
            opacity: 0.1,
          },
        },
        markers: {
          size: 1,
        },
        xaxis: {
          type: "datetime",
          // title: {
          //   text: "Date"
          // },
          min: new Date().getTime() - 86400000 * 30,
          max: new Date().getTime() - 86400000 / 4,
        },
        yaxis: {
          title: {
            text: "คน",
          },
          labels: {
            formatter: function (val) {
              return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
            },
          },
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
          floating: true,
          offsetY: -25,
          offsetX: -5,
        },
      },
      series: [],
      seriesNewConfirmed: [],
      headers: [
        {
          text: "ลำดับ",
          align: "end",
          sortable: true,
          value: "no",
        },
        { text: "เพศ", value: "sex" },
        { text: "อายุ", value: "age" },
        { text: "สัญชาติ", value: "nation" },
        // { text: "อาชีพ", value: "occ_new" }
      ],
      rangeHeaders: [
        { text: "จังหวัด", value: "province" },
        { text: "จำนวนผู้ติดเชื้อ", value: "total_case", align: "end" },
      ],
      provinceCaseTable: [],
      provinceCaseRangeTable: [],
      barSeries: [
        {
          name: "Male",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Female",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      ],
      barChartOptions: {
        chart: {
          type: "bar",
          height: 440,
          stacked: true,
        },
        colors: ["#008FFB", "#FF4560"],
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "100%",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        grid: {
          xaxis: {
            lines: {
              show: false,
            },
          },
        },
        yaxis: {
          labels: {
            minWidth: 10,
          },
          //   min: -5,
          //   max: 5,
          title: {
            // text: 'Age',
          },
        },
        tooltip: {
          shared: false,
          x: {
            formatter: function (val) {
              return val;
            },
          },
          y: {
            formatter: function (val) {
              return Math.abs(val);
            },
          },
        },
        xaxis: {
          categories: [
            "85+",
            "80-84",
            "75-79",
            "70-74",
            "65-69",
            "60-64",
            "55-59",
            "50-54",
            "45-49",
            "40-44",
            "35-39",
            "30-34",
            "25-29",
            "20-24",
            "15-19",
            "10-14",
            "5-9",
            "0-4",
            "ยังไม่ระบุ",
          ],
          title: {
            text: "Percent",
          },
          labels: {
            formatter: function (val) {
              return Math.round(val);
            },
          },
        },
      },
    };
  },
  mounted() {
    let self = this;
    if ("mode" in self.$route.query) {
      self.isMode = self.$route.query.mode;
    }
    if (window.innerWidth < 600) {
      self.isMobile = true;
    }

    self.initMap(); // Initialize the map and bind some event
    self.loadProvinceData(); // load data for province charts
    let tempDataSeries = [];
    Vue.axios
      .get("https://covid19.ddc.moph.go.th/api/Cases/timeline-cases-all")
      .then((response) => {
        tempDataSeries = [
          {
            name: "สะสม",
            data: [],
          },
          {
            name: "รักษา",
            data: [],
          },
          {
            name: "หาย",
            data: [],
          },
          {
            name: "เสียชีวิต",
            data: [],
          },
        ];
        self.seriesNewConfirmed = [
          {
            name: "ผู้ป่วยยืนยัน",
            data: [],
          },
        ];
        // let tempGraph = 5000;
        // self.thailandChartOptions.xaxis.min = undefined;
        // self.thailandChartOptions.xaxis.max = undefined;
        response.data.forEach((element) => {
          if (element.new_case > 0) {
            tempDataSeries[0].data.push({
              x: element.txn_date,
              y: element.new_case,
            });
          }
          self.seriesNewConfirmed[0].data.push({
            x: element.txn_date,
            y: element.new_case,
          });
          // if (element.Hospitalized > 0) {
          //   tempDataSeries[1].data.push({
          //     x: element.txn_date,
          //     y: element.Hospitalized,
          //   });
          // }

          if (element.new_recovered > 0) {
            tempDataSeries[2].data.push({
              x: element.txn_date,
              y: element.new_recovered,
            });
          }

          if (element.new_death > 0) {
            tempDataSeries[3].data.push({ x: element.txn_date, y: element.new_death });
          }
        });
        // console.log(tempDataSeries[0].data[tempDataSeries[0].data.length - 1].y);
        self.makeChart(tempDataSeries);
      });
  },
  methods: {
    makeChart(tempSeries) {
      const self = this;
      self.series = tempSeries;
    },
    //load cases service from covid19-th-stats
    loadProvinceData() {
      let self = this;
      // https://covid19.ddc.moph.go.th/api/Cases/today-cases-by-provinces
      Vue.axios
        .get(
          "https://covid19.ddc.moph.go.th/api/Cases/today-cases-by-provinces"
        )
        .then((response) => {
          self.timelineJson = response.data;
          // let tempCovidProvince = {};
          self.provinceCaseRangeTable = response.data;
          // response.data.forEach(function (a) {
          //   tempCovidProvince[a.province] =
          //     (tempCovidProvince[a.province] || 0) + 1;
          // });
          // console.log(tempCovidProvince)
          // self.makeBarChartAge(response.data.Data); // make an age bar chart
          self.makeWKTPolygon(self.timelineJson);
          // self.bindMapClickProvince();
          // self.makeRangeProvince(tempCovidProvince);
        });
    },
    initMap() {
      let self = this;
      self.map = new window.longdo.Map({
        placeholder: document.getElementById("map"),
        ui: window.longdo.UiComponent.Mobile,
      });
      self.map.Ui.LayerSelector.visible(false);
      self.map.location({ lat: 14.074441, lon: 100.600873 });
      self.map.zoom(6);
      // console.log(self.map.Ui.BottomRight);
      // console.log(this.$refs["bottonActiveteMap"].$el);
      // self.map.Ui.BottomRight.appendChild(this.$refs["bottonActiveteMap"].$el);
      // let mapToolContainer = document.getElementById("show-more-map-button");
      // self.map.Ui.TopRight.insertBefore(
      //   mapToolContainer,
      //   self.map.Ui.TopRight.childNodes[0]
      // );

      self.map.Event.bind("overlayHover", (obj) => {
        if (obj instanceof window.longdo.Polygon) {
          self.isInSelectedPolygon = false;
          if (self.selectedPolygon) {
            self.selectedPolygon.ward.polygonList.forEach((p) => {
              if (p === obj) {
                self.isInSelectedPolygon = true;
              }
            });
          }
          if (!self.isInSelectedPolygon) {
            obj.update({
              lineWidth: 2,
            });
          }
        }
      });

      self.map.Event.bind("overlayLeave", (obj) => {
        if (obj instanceof window.longdo.Polygon) {
          self.isInSelectedPolygon = false;
          if (self.selectedPolygon) {
            self.selectedPolygon.ward.polygonList.forEach((p) => {
              if (p === obj) {
                self.isInSelectedPolygon = true;
              }
            });
          }
          if (!self.isInSelectedPolygon) {
            obj.update({
              lineWidth: 1,
            });
          }
        }
      });
    },
    bindMapClickProvince() {
      let self = this;
      self.map.Event.bind("overlayClick", (obj) => {
        let _provinceCaseTable = [];
        self.provinceCaseTable = [];
        self.seletedProvince = "จ." + obj.title;
        self.tab = 2;
        if (obj instanceof window.longdo.Polygon) {
          self.timelineJson.Data.forEach((x) => {
            if (x.Province === obj.title) {
              _provinceCaseTable.push({
                no: Number(x.No),
                sex: x.Gender,
                age: parseInt(x.Age),
                nation: x.Nation,
              });
            }
          });
        }
        self.provinceCaseTable = _provinceCaseTable;
      });
    },
    makeRangeProvince(params) {
      let self = this;
      for (let [key, value] of Object.entries(params)) {
        self.provinceCaseRangeTable.push({
          value: Number(`${value}`),
          province: `${key}`,
        });
      }
    },
    makeWKTPolygon(params) {
      let self = this;
      let tempValue = "";
      self.tempFillColor = "rgba(255, 255, 255, 0.8)";
      self.thailandLowWKT.forEach((element) => {
        params.forEach((x) => {
          if (element.name_th === x.province) {
            self.tempFillColor = self.assignColor(Number(x.total_case));
            tempValue = x.total_case;
          }
        });

        element.polygonList = new window.longdo.Util.overlayFromWkt(
          element.WKT,
          {
            lineColor: "rgba(0, 0, 0, 1)",
            lineWidth: 1,
            fillColor: self.tempFillColor,
            clickable: true,
            title: element.name_th,
            label: tempValue,
          }
        );
        tempValue = 0;

        element.polygonList.forEach((p) => {
          self.map.Overlays.add(p);
        });
        self.tempFillColor = "rgba(255, 255, 255, 0.8)";
      });
    },
    makeBarChartAge(result) {
      let self = this;
      result.forEach((x) => {
        if (x.Gender === "ชาย") {
          self.checkRangeAge(x.Age, 0);
        } else if (x.Gender === "หญิง") {
          self.checkRangeAge(x.Age, 1);
        } else {
          // console.log();
        }
      });
    },
    assignColor(numberCase) {
      if (numberCase < 1000) {
        return "rgba(254,240,217,0.8)";
      } else if (numberCase < 5000) {
        return "rgba(253,204,138, 0.8)";
      } else if (numberCase < 10000) {
        return "rgba(252,141,89, 0.8)";
      } else if (numberCase < 30000) {
        return "rgba(227,74,51, 0.8)";
      } else {
        return "rgba(179,0,0, 1)";
      }
    },
    numberWithCommas(x) {
      // console.log(x.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'));
      return x.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    checkRangeAge(age, index) {
      let self = this;
      if (parseInt(age) > 84) {
        self.barSeries[index].data[0] += 1;
      } else if (parseInt(age) > 79) {
        self.barSeries[index].data[1] += 1;
      } else if (parseInt(age) > 74) {
        self.barSeries[index].data[2] += 1;
      } else if (parseInt(age) > 69) {
        self.barSeries[index].data[3] += 1;
      } else if (parseInt(age) > 64) {
        self.barSeries[index].data[4] += 1;
      } else if (parseInt(age) > 59) {
        self.barSeries[index].data[5] += 1;
      } else if (parseInt(age) > 54) {
        self.barSeries[index].data[6] += 1;
      } else if (parseInt(age) > 49) {
        self.barSeries[index].data[7] += 1;
      } else if (parseInt(age) > 44) {
        self.barSeries[index].data[8] += 1;
      } else if (parseInt(age) > 39) {
        self.barSeries[index].data[9] += 1;
      } else if (parseInt(age) > 34) {
        self.barSeries[index].data[10] += 1;
      } else if (parseInt(age) > 29) {
        self.barSeries[index].data[11] += 1;
      } else if (parseInt(age) > 24) {
        self.barSeries[index].data[12] += 1;
      } else if (parseInt(age) > 19) {
        self.barSeries[index].data[13] += 1;
      } else if (parseInt(age) > 14) {
        self.barSeries[index].data[14] += 1;
      } else if (parseInt(age) > 9) {
        self.barSeries[index].data[15] += 1;
      } else if (parseInt(age) > 4) {
        self.barSeries[index].data[16] += 1;
      } else if (parseInt(age) > 0) {
        self.barSeries[index].data[17] += 1;
      } else {
        self.barSeries[index].data[18] += 1;
      }
    },
    toggleBlockMap() {
      let self = this;
      self.map.resize();
      if (self.isToggleBlockMap === true) {
        self.isToggleBlockMap = false;
        self.btnBlockMapTxt = "ล็อกแผนที่";
      } else {
        self.isToggleBlockMap = true;
        self.btnBlockMapTxt = "เลื่อนแผนที่";
      }
      // console.log('toggle')
    },
  },
};
</script>

<style scoped>
#map {
  height: 500px;
  max-height: 500px;
}
.copyright {
  bottom: 0px;
  color: #fff;
  padding: 10px;
  font-size: 13px;
  text-align: start;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.copyright > div {
  /* margin-left: 10px; */
  display: flex;
  flex-direction: row;
  align-items: center;
}
.copyright > div > {
  margin-left: 10px;
}
.copyright-mobile {
  display: none;
}
.column-container {
  display: flex;
  flex-direction: column;
  padding: 4px;
  min-width: 300px;
}
#mobile-block-map {
}
.div-overlay-map {
  position: absolute;
  height: 500px;
  width: 100%;
  display: none;
}
#show-more-map-button {
  position: absolute;
  z-index: 6;
  right: 38px;
  margin-top: 10px;
}
#lock-map-button {
  position: absolute;
  z-index: 6;
  right: 38px;
  bottom: 40px;
  /* margin-bottom: 10px; */
}
.botton-activete-map {
  display: none;
}
.column-container {
  position: sticky;
}
@media screen and (max-width: 768px) {
}
@media only screen and (max-width: 600px) {
  .detail {
    height: auto;
    padding: 10px;
  }
  .botton-activete-map {
    position: absolute;
    right: 10px;
    z-index: 1000;
    bottom: 35px;
    display: block;
  }
  #mobile-block-map {
    display: block;
    background-color: #000;
    z-index: 5;
    opacity: 0.1;
  }
  #button-block-map {
    display: block;
    z-index: 200;
  }
  .column-container {
    padding: 0px;
  }
  .copyright {
    display: none;
    color: #ffffff;
  }
  .copyright-mobile {
    display: block;
  }
  /* .v-tabs-bar.v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows):not(.v-slide-group--has-affixes)
    .v-slide-group__prev {
    display: none !important;
  } */
}
</style>
